module.exports = __webpack_public_path__ + "static/media/save-search-banner.24d12ad9.png";